import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

const initialState = {
  orders: [],
  order: null,
  loadingIrdOrders: LOADING_STATUS.notLoading,
  loadingIrdOrder: LOADING_STATUS.notLoading,
};

export const irdOrdersSlice = createSlice({
  name: 'irdOrders',
  initialState,
  reducers: {
    setLoadingOrders: (state, action) => {
      state.loadingIrdOrders = action.payload;
    },
    setLoadingOrder: (state, action) => {
      state.loadingIrdOrder = action.payload;
    },
    setOrders: (state, action) => {
      const { orders } = action.payload;
      state.orders = orders;
    },
    setOrder: (state, action) => {
      const { order } = action.payload;
      state.order = order;
    },
    cleanIrdOrdersSlice() {
      return initialState;
    },
  },
});

export const {
  cleanIrdOrdersSlice,
  setLoadingOrder,
  setLoadingOrders,
  setOrder,
  setOrders,
} = irdOrdersSlice.actions;

export default irdOrdersSlice.reducer;
